import { useState, useEffect } from 'preact/hooks';
import {formatDateTime,getInitials,getFormattedAmount} from '../../lib/utils';
import axios from "axios";
import CONSTANTS from '../../lib/constants';
import ListSingleCardWizard from '../listSingleCardWizard';
import moment from 'moment';
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
import { route } from 'preact-router';
import { getItem } from '../../lib/myStore';

const ListSingleCard = (props) => {
  let userInfo = getItem('userinfo');
  let [dataSet, setDataset] = useState(props.taskData);
  let [selectedList, setSelectedList] = useState('');
  let [selectedInsuranceCompany, setSelectedInsuranceCompany] = useState('');
  let [lastQuotation, setLastQuotation] = useState({});
  let [followups, setFollowUps] = useState(props.followups);
  let [quotations, setQuotations] = useState(props.quotations);

  useEffect(async () => {
    try {
      await setDataset(props.taskData);
      if (props.taskData && props.taskData.interactionID) {
        let quotations = await axios.get(`${CONSTANTS.API_URL}/api/v1/quotation?interactionID=${props.taskData.interactionID}`);
        await setLastQuotation(quotations.data);
      }
      if (props.typeOfCard === 'renewalCaseDetails') {
        let selectedInsuranceCompany = '';
        if (dataSet.interaction && dataSet.interaction['dynamicProperties_payeeName']) {
          selectedInsuranceCompany = dataSet.interaction['dynamicProperties_payeeName'];
        } else if (dataSet && dataSet.interaction) {
          if (dataSet.interaction["insuranceCompanyID"]) {
            props.insuranceCompanies.map((item) => {
              if (dataSet.interaction["insuranceCompanyID"] === item.uuid) selectedInsuranceCompany = item.displayName;
            });
          }
          if (dataSet.interaction["insuranceCompanyID2"]) {
            props.insuranceCompanies.map((item) => {
              if (dataSet.interaction["insuranceCompanyID2"] === item.uuid) selectedInsuranceCompany = item.displayName;
            });
          }
          if (dataSet.interaction["insuranceCompanyRenewalID"]) {
            props.insuranceCompanies.map((item) => {
              if (dataSet.interaction["insuranceCompanyRenewalID"] === item.uuid) selectedInsuranceCompany = item.displayName;
            });
          }
        }
        setSelectedInsuranceCompany(selectedInsuranceCompany);
      }
      setFollowUps(props.followups);
      setQuotations(props.quotations);
    } catch (HTTPException) {
      if (HTTPException && HTTPException.config && HTTPException.config.url) {
        let payload = {
          apiURL: HTTPException.config.url,
          errorObject:HTTPException,
          statusCode:(HTTPException && HTTPException.response && HTTPException.response.status) ? HTTPException.response.status : 0,
          errorMessage:HTTPException.message,
          functionName:"useEffect-[props.taskData, props.followups, props.quotations]",
          fileName:"listSingleCard",
          pageName: "listSingleCard",
          userID:userInfo.uuid,
          userName:userInfo.displayName
        };
        await axios.post(`${CONSTANTS.API_URL}/api/v1/exception`, payload);
      }
      return HTTPException;
    }
  },[props.taskData, props.followups, props.quotations]);

  function handleData(row) {
    setSelectedList(row.uuid);
    props.showData(row);
  }

  function viewAllImages(e,id, index) {
    let options = {
      rotatable:false,
      scalable:false
    };
    const gallery = new Viewer(document.getElementById(`image-${index}-${id}`),options);
    gallery.show();
  }
  function routeToCaseDetails() {
    route(`/caseDetails/${dataSet.uuid}`);
  }
  return (
    <div>
      {props.typeOfCard === 'caseSingleDetails' && dataSet &&
        <div class="listCard fadeAnimationText m-t-5 m-b-5 pos-relative">
          <div class='msgContainer cursor-pointer animatedHover min-h-inherit'>
            <div class='display-flex justify-between align-center m-l-10 min-h-inherit'>
              <div class="display-flex align-center">
                <div class="h-24px w-24px">
                  {props.taskIcon}
                </div>
                <div class="display-flex flex-direction-column m-l-10 m-r-10">
                  <p class='fs-10 f-w-600 text-grey'>{dataSet.caseID ? dataSet.caseID : dataSet.uniqueID ? dataSet.uniqueID : ''}</p>
                  <p class='fs-14 first-letter-capital'>{dataSet.lastCompletedAction}</p>
                </div>
              </div>
              <div class="display-flex flex-direction-column m-l-10 m-r-10">
                <p class='fs-10 f-w-600 text-grey'>Last Quotation</p>
                <p class='fs-14 first-letter-capital'>{lastQuotation ? lastQuotation: "-"}</p>
              </div>
              <div class={'m-r-30 tasks-tags border-tenant'}>
                <div class="display-flex flex-direction-column fs-10">
                  <p class="f-w-600">{dataSet.currentStage}</p>
                </div>
              </div>
            </div>
          </div>
          <span class="h-full pos-absolute color-white fs-9 text-center text-uppercase list-card-ribbon" style={`background:${ dataSet.group === "task" ? "#20639B": dataSet.group === "Approval"? "#2F9395":""}`}>{ dataSet.group === "task" ? "Task" :(dataSet.group === "Approval") ? "Approval":""}</span>
        </div>
      }
      {props.typeOfCard === 'caseDetails' && dataSet &&
        <div class="row">
          <div class='col-xs-12 col-sm-6 col-md-6 col-lg-6 p-l-0 p-r-5' >
            <div class="workspace-cards fadeMoveUpAnimation">
              <div class="row justify-between align-center">
                <div class="display-flex">
                  <span class="workspace-cardsnumber fs-16 f-w-500">
                    <div class="h-24px w-24px">
                      {props.caseIcon}
                    </div>
                  </span>
                  <span class="m-l-10 fs-14 align-self-center">{dataSet.caseID ? dataSet.caseID : dataSet.uniqueID ? dataSet.uniqueID : ''}</span>
                </div>
              </div>
              <div class="row m-t-10">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Customer Name</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(dataSet.interaction && dataSet.interaction["dynamicProperties_customerName"]) ? dataSet.interaction["dynamicProperties_customerName"]: "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Source</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(dataSet.interaction && dataSet.interaction["dynamicProperties_source"]) ? dataSet.interaction["dynamicProperties_source"]: "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Mobile</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(dataSet.interaction && dataSet.interaction["dynamicProperties_mobile"]) ? dataSet.interaction["dynamicProperties_mobile"]: "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Email</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(dataSet.interaction && (dataSet.interaction["dynamicProperties_email"] && dataSet.interaction["dynamicProperties_email"] !== "NOT FOUND")) ? dataSet.interaction["dynamicProperties_email"]: "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Purchased Model</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.model ? dataSet.model : (dataSet.interaction && dataSet.interaction['dynamicProperties_selectedModelName']) ? dataSet.interaction['dynamicProperties_selectedModelName']: '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Purchased Variant</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.variant ? dataSet.variant : (dataSet.interaction && dataSet.interaction['dynamicProperties_selectedVariantName']) ? dataSet.interaction['dynamicProperties_selectedVariantName']: '--'}</span></span>
                  </div>
                  {/*<div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">No. of Visitors</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.visitDetails && dataSet.visitDetails.noOfVisitors ? dataSet.visitDetails.noOfVisitors : '01'}</span></span>
                  </div>*/}
                </div>
              </div>
            </div>
          </div>
          <div class='col-xs-12 col-sm-6 col-md-6 col-lg-6 p-l-5 p-r-0'>
            <div class="workspace-cards fadeMoveUpAnimation">
              <div class="row justify-between align-center">
                <div class="display-flex">
                  <span class="workspace-cardsnumber fs-16 f-w-500">
                    <div class="h-24px w-24px">
                      {props.stageIcon}
                    </div>
                  </span>
                  <span class="m-l-10 fs-14 align-self-center">STAGE</span>
                </div>
              </div>
              <div class="row m-t-10">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">{dataSet.currentStage ? dataSet.currentStage : '--'}</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.currentStageActiveSince ? dataSet.currentStageActiveSince + ' Days' : '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Next Stage</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.nextStage ? dataSet.nextStage : '--'}</span></span>
                  </div>
                  {(dataSet && dataSet.completedTasks > 0 && dataSet.pendingTasks > 0) &&
                    <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                      <div class="flex-sb">
                        <span class="fs-14">{`${dataSet.pendingTasks}  Completed out of /  ${dataSet.completedTasks}`}</span>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
            {/*<div class="workspace-cards fadeMoveUpAnimation" style='margin-top:10px'>
              <div class="row justify-between align-center">
                <div class="display-flex">
                  <span class="workspace-cardsnumber fs-16 f-w-500">
                    <div class="h-24px w-24px">
                      {props.stageIcon}
                    </div>
                  </span>
                  <span class="m-l-10 fs-14 align-self-center">INFORMATION</span>
                </div>
              </div>
              <div class="row m-t-10">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                  {
                    (dataSet && dataSet.status !== 'Completed' && (!dataSet.incompleteTasks || dataSet.incompleteTasks.length === 0) && (
                      <span>{`Current state of this task is ${dataSet.status}. Please proceed by clicking ${dataSet.displayName} to complete the task`}</span>

                    ))
                  }
                  {
                    (dataSet && dataSet.status === 'Completed' && (!dataSet.incompleteTasks || dataSet.incompleteTasks.length === 0) && dataSet.nextTask && dataSet.nextTask.status && dataSet.nextTask.status.toLowerCase() !== "completed" && (
                      <span>{`Current state of the task is Complete. Next task to perform is ${dataSet.nextTask.displayName}. Click on the button below to
                      proceed to next task.`}</span>
                    ))
                  }
                  {
                    (dataSet && dataSet.status === 'Completed' && (!dataSet.incompleteTasks || dataSet.incompleteTasks.length === 0) && dataSet.nextTask && dataSet.nextTask.status && dataSet.nextTask.status.toLowerCase() === "completed" && (
                      <span>{`This task has been completed. You can view the form by clicking the ${dataSet.displayName} button below`}</span>
                    ))
                  }
                  {
                    (dataSet && dataSet.status === 'Completed' && (!dataSet.incompleteTasks || dataSet.incompleteTasks.length === 0) && !dataSet.nextTask && (
                      <span>{`This task has been completed. You can view the form by clicking the ${dataSet.displayName} button below`}</span>
                    ))
                  }
                  {
                    (dataSet && !dataSet.areDependentTasksCompleted && dataSet.incompleteTasks && dataSet.incompleteTasks.length > 0 && dataSet.status !== "Completed" ) && (
                      <span>{`Current state of the task is Pending. You will not be able to perform this task unless below task(s) are completed:`}</span>
                    )
                  }
                  {
                    (dataSet && !dataSet.areDependentTasksCompleted && dataSet.incompleteTasks && dataSet.incompleteTasks.length > 0 && dataSet.status !== "Completed" ) && (
                      <div class="bor-t">
                        {
                          dataSet.incompleteTasks.map((task, index) => (
                            <span>{index+1}. {task}<br /></span>
                          ))
                        }
                      </div>
                    )
                  }
                  {(dataSet && dataSet.completedTasks > 0 && dataSet.pendingTasks > 0) &&
                    <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                      <div class="flex-sb">
                        <span class="fs-14">{`${dataSet.pendingTasks}  Completed out of /  ${dataSet.completedTasks}`}</span>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>*/}
          </div>
        </div>
      }
      {props.typeOfCard === 'renewalCaseDetails' && dataSet &&
        <div class="row">
          <div class='col-xs-12 col-sm-6 col-md-6 col-lg-6 p-l-0 p-r-5' >
            <div class="workspace-cards fadeMoveUpAnimation">
              <div class="row justify-between align-center">
                <div class="display-flex">
                  <span class="workspace-cardsnumber fs-16 f-w-500">
                    <div class="h-24px w-24px">
                      {props.caseIcon}
                    </div>
                  </span>
                  <span class="m-l-10 fs-14 align-self-center">{dataSet.caseID ? dataSet.caseID : dataSet.uniqueID ? dataSet.uniqueID : ''}</span>
                </div>
              </div>
              <div class="row m-t-10">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Customer Name</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(dataSet.interaction && dataSet.interaction["dynamicProperties_customerName"]) ? dataSet.interaction["dynamicProperties_customerName"]: "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Mobile</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(dataSet.interaction && dataSet.interaction["dynamicProperties_mobile"]) ? dataSet.interaction["dynamicProperties_mobile"]: "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Email</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(dataSet.interaction && (dataSet.interaction["dynamicProperties_email"] && dataSet.interaction["dynamicProperties_email"] !== "NOT FOUND")) ? dataSet.interaction["dynamicProperties_email"]: "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Source</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(dataSet.interaction && dataSet.interaction["dynamicProperties_source"]) ? dataSet.interaction["dynamicProperties_source"]: "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Purchased Model</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.model ? dataSet.model : (dataSet.interaction && dataSet.interaction['dynamicProperties_selectedModel']) ? dataSet.interaction['dynamicProperties_selectedModel']: '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Chassis No.</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.interaction && dataSet.interaction['dynamicProperties_vin'] ? dataSet.interaction['dynamicProperties_vin'] : '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Registration No.</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.interaction && dataSet.interaction['dynamicProperties_registrationNo'] ? dataSet.interaction['dynamicProperties_registrationNo'] : '--'}</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class='col-xs-12 col-sm-6 col-md-6 col-lg-6 p-l-5 p-r-0'>
            <div class="workspace-cards fadeMoveUpAnimation">
              <div class="row justify-between align-center">
                <div class="display-flex">
                  <span class="workspace-cardsnumber fs-16 f-w-500">
                    <div class="h-24px w-24px">
                      {props.stageIcon}
                    </div>
                  </span>
                  <span class="m-l-10 fs-14 align-self-center">Policy Details</span>
                </div>
              </div>
              <div class="row m-t-10">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Policy Number</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.interaction && dataSet.interaction['dynamicProperties_currentPolicyNo'] ? dataSet.interaction['dynamicProperties_currentPolicyNo'] : '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Policy Start Date</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.interaction && dataSet.interaction['dynamicProperties_startDate'] ? formatDateTime(dataSet.interaction['dynamicProperties_startDate']) : '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Policy Expiry Date</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.interaction && dataSet.interaction['dynamicProperties_endDate'] ? formatDateTime(dataSet.interaction['dynamicProperties_endDate']) : '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Insurance Company</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">
                      {selectedInsuranceCompany ? selectedInsuranceCompany : '--'}
                    </span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Manufacturing Year</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.interaction && dataSet.interaction['dynamicProperties_manufactureYear'] ? dataSet.interaction['dynamicProperties_manufactureYear'] : '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Month</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.interaction && dataSet.interaction['dynamicProperties_month'] ? dataSet.interaction['dynamicProperties_month'] : '--'}</span></span>
                  </div>
                </div>
              </div>
            </div>
            {/*<div class="workspace-cards fadeMoveUpAnimation" style='margin-top:10px'>
              <div class="row justify-between align-center">
                <div class="display-flex">
                  <span class="workspace-cardsnumber fs-16 f-w-500">
                    <div class="h-24px w-24px">
                      {props.stageIcon}
                    </div>
                  </span>
                  <span class="m-l-10 fs-14 align-self-center">INFORMATION</span>
                </div>
              </div>
              <div class="row m-t-10">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                  {
                    (dataSet && dataSet.status !== 'Completed' && (!dataSet.incompleteTasks || dataSet.incompleteTasks.length === 0) && (
                      <span>{`Current state of this task is ${dataSet.status}. Please proceed by clicking ${dataSet.displayName} to complete the task`}</span>

                    ))
                  }
                  {
                    (dataSet && dataSet.status === 'Completed' && (!dataSet.incompleteTasks || dataSet.incompleteTasks.length === 0) && dataSet.nextTask && dataSet.nextTask.status && dataSet.nextTask.status.toLowerCase() !== "completed" && (
                      <span>{`Current state of the task is Complete. Next task to perform is ${dataSet.nextTask.displayName}. Click on the button below to
                      proceed to next task.`}</span>
                    ))
                  }
                  {
                    (dataSet && dataSet.status === 'Completed' && (!dataSet.incompleteTasks || dataSet.incompleteTasks.length === 0) && dataSet.nextTask && dataSet.nextTask.status && dataSet.nextTask.status.toLowerCase() === "completed" && (
                      <span>{`This task has been completed. You can view the form by clicking the ${dataSet.displayName} button below`}</span>
                    ))
                  }
                  {
                    (dataSet && dataSet.status === 'Completed' && (!dataSet.incompleteTasks || dataSet.incompleteTasks.length === 0) && !dataSet.nextTask && (
                      <span>{`This task has been completed. You can view the form by clicking the ${dataSet.displayName} button below`}</span>
                    ))
                  }
                  {
                    (dataSet && !dataSet.areDependentTasksCompleted && dataSet.incompleteTasks && dataSet.incompleteTasks.length > 0 && dataSet.status !== "Completed" ) && (
                      <span>{`Current state of the task is Pending. You will not be able to perform this task unless below task(s) are completed:`}</span>
                    )
                  }
                  {
                    (dataSet && !dataSet.areDependentTasksCompleted && dataSet.incompleteTasks && dataSet.incompleteTasks.length > 0 && dataSet.status !== "Completed" ) && (
                      <div class="bor-t">
                        {
                          dataSet.incompleteTasks.map((task, index) => (
                            <span>{index+1}. {task}<br /></span>
                          ))
                        }
                      </div>
                    )
                  }
                  {(dataSet && dataSet.completedTasks > 0 && dataSet.pendingTasks > 0) &&
                    <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                      <div class="flex-sb">
                        <span class="fs-14">{`${dataSet.pendingTasks}  Completed out of /  ${dataSet.completedTasks}`}</span>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>*/}
          </div>
        </div>
      }
      {props.typeOfCard === 'caseListDetails' && dataSet &&
        <div class="row">
          <div class='col-xs-12 col-sm-6 col-md-6 col-lg-6 p-l-0 p-r-5' >
            <div class="workspace-cards fadeMoveUpAnimation">
              <div class="row justify-between align-center">
                <div class="display-flex">
                  <span class="workspace-cardsnumber fs-16 f-w-500">
                    <div class="h-24px w-24px">
                      {props.caseIcon}
                    </div>
                  </span>
                  <span class="m-l-10 fs-14 align-self-center cursor-pointer" title="Click to view Case Details" onClick={(e) => routeToCaseDetails(e)}>{dataSet.caseID ? dataSet.caseID : dataSet.uniqueID ? dataSet.uniqueID : ''}</span>
                </div>
              </div>
              <div class="row m-t-10">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Customer Name</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(dataSet && dataSet["dynamicProperties_customerName"]) ? dataSet["dynamicProperties_customerName"]: "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Source</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(dataSet && dataSet["dynamicProperties_source"]) ? dataSet["dynamicProperties_source"]: "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Purchased Model</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.model ? dataSet.model : (dataSet && dataSet['dynamicProperties_selectedModel']) ? dataSet['dynamicProperties_selectedModel']: '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Chassis No.</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet && dataSet['dynamicProperties_vin'] ? dataSet['dynamicProperties_vin'] : '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Registration No.</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet && dataSet['dynamicProperties_registrationNo'] ? dataSet['dynamicProperties_registrationNo'] : '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Manufacturing Year</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet && dataSet['dynamicProperties_manufactureYear'] ? dataSet['dynamicProperties_manufactureYear'] : '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Month</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet && dataSet['dynamicProperties_month'] ? dataSet['dynamicProperties_month'] : '--'}</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class='col-xs-12 col-sm-6 col-md-6 col-lg-6 p-l-5 p-r-0'>
            <div class="workspace-cards fadeMoveUpAnimation">
              <div class="row justify-between align-center">
                <div class="display-flex">
                  <span class="workspace-cardsnumber fs-16 f-w-500">
                    <div class="h-24px w-24px">
                      {props.stageIcon}
                    </div>
                  </span>
                  <span class="m-l-10 fs-14 align-self-center">Policy Details</span>
                </div>
              </div>
              <div class="row m-t-10">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Policy Number</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet && dataSet['dynamicProperties_currentPolicyNo'] ? dataSet['dynamicProperties_currentPolicyNo'] : '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Policy Start Date</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet && dataSet['dynamicProperties_startDate'] ? dataSet['dynamicProperties_startDate'] : '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Policy Expiry Date</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet && dataSet['dynamicProperties_endDate'] ? dataSet['dynamicProperties_endDate'] : '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Insurance Company</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">
                      {selectedInsuranceCompany ? selectedInsuranceCompany : '--'}
                    </span></span>
                  </div>
                </div>
              </div>
            </div>
            {/*<div class="workspace-cards fadeMoveUpAnimation" style='margin-top:10px'>
              <div class="row justify-between align-center">
                <div class="display-flex">
                  <span class="workspace-cardsnumber fs-16 f-w-500">
                    <div class="h-24px w-24px">
                      {props.stageIcon}
                    </div>
                  </span>
                  <span class="m-l-10 fs-14 align-self-center">INFORMATION</span>
                </div>
              </div>
              <div class="row m-t-10">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                  {
                    (dataSet && dataSet.status !== 'Completed' && (!dataSet.incompleteTasks || dataSet.incompleteTasks.length === 0) && (
                      <span>{`Current state of this task is ${dataSet.status}. Please proceed by clicking ${dataSet.displayName} to complete the task`}</span>

                    ))
                  }
                  {
                    (dataSet && dataSet.status === 'Completed' && (!dataSet.incompleteTasks || dataSet.incompleteTasks.length === 0) && dataSet.nextTask && dataSet.nextTask.status && dataSet.nextTask.status.toLowerCase() !== "completed" && (
                      <span>{`Current state of the task is Complete. Next task to perform is ${dataSet.nextTask.displayName}. Click on the button below to
                      proceed to next task.`}</span>
                    ))
                  }
                  {
                    (dataSet && dataSet.status === 'Completed' && (!dataSet.incompleteTasks || dataSet.incompleteTasks.length === 0) && dataSet.nextTask && dataSet.nextTask.status && dataSet.nextTask.status.toLowerCase() === "completed" && (
                      <span>{`This task has been completed. You can view the form by clicking the ${dataSet.displayName} button below`}</span>
                    ))
                  }
                  {
                    (dataSet && dataSet.status === 'Completed' && (!dataSet.incompleteTasks || dataSet.incompleteTasks.length === 0) && !dataSet.nextTask && (
                      <span>{`This task has been completed. You can view the form by clicking the ${dataSet.displayName} button below`}</span>
                    ))
                  }
                  {
                    (dataSet && !dataSet.areDependentTasksCompleted && dataSet.incompleteTasks && dataSet.incompleteTasks.length > 0 && dataSet.status !== "Completed" ) && (
                      <span>{`Current state of the task is Pending. You will not be able to perform this task unless below task(s) are completed:`}</span>
                    )
                  }
                  {
                    (dataSet && !dataSet.areDependentTasksCompleted && dataSet.incompleteTasks && dataSet.incompleteTasks.length > 0 && dataSet.status !== "Completed" ) && (
                      <div class="bor-t">
                        {
                          dataSet.incompleteTasks.map((task, index) => (
                            <span>{index+1}. {task}<br /></span>
                          ))
                        }
                      </div>
                    )
                  }
                  {(dataSet && dataSet.completedTasks > 0 && dataSet.pendingTasks > 0) &&
                    <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                      <div class="flex-sb">
                        <span class="fs-14">{`${dataSet.pendingTasks}  Completed out of /  ${dataSet.completedTasks}`}</span>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>*/}
          </div>
        </div>
      }
      <div>
        <ListSingleCardWizard quotations={quotations} followups={followups} insuranceCompanies={props.insuranceCompanies} currentRow={dataSet} />
      </div>
      {((props.typeOfCard === 'renewalCaseDetails' || props.typeOfCard === 'caseDetails') && dataSet) &&
        <div class="row">
          <div class='col-xs-12 col-sm-12 col-md-12 col-lg-12 p-l-0 p-r-0'>
            <div class="workspace-cards fadeMoveUpAnimation" style='margin-top:10px'>
              <div class="row justify-between align-center">
                <div class="display-flex">
                  <span class="workspace-cardsnumber fs-16 f-w-500">
                    <div class="h-24px w-24px">
                      {props.stageIcon}
                    </div>
                  </span>
                  <span class="m-l-10 fs-14 align-self-center">INFORMATION</span>
                </div>
              </div>
              <div class="row m-t-10">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                  {
                    (dataSet && dataSet.status !== 'Completed' && (!dataSet.incompleteTasks || dataSet.incompleteTasks.length === 0) && (
                      <span>{`Current state of this task is ${dataSet.status}. Please proceed by clicking ${dataSet.displayName} to complete the task`}</span>

                    ))
                  }
                  {
                    (dataSet && dataSet.status === 'Completed' && (!dataSet.incompleteTasks || dataSet.incompleteTasks.length === 0) && dataSet.nextTask && dataSet.nextTask.status && dataSet.nextTask.status.toLowerCase() !== "completed" && (
                      <span>{`Current state of the task is Complete. Next task to perform is ${dataSet.nextTask.displayName}. Click on the button below to
                      proceed to next task.`}</span>
                    ))
                  }
                  {
                    (dataSet && dataSet.status === 'Completed' && (!dataSet.incompleteTasks || dataSet.incompleteTasks.length === 0) && dataSet.nextTask && dataSet.nextTask.status && dataSet.nextTask.status.toLowerCase() === "completed" && (
                      <span>{`This task has been completed. You can view the form by clicking the ${dataSet.displayName} button below`}</span>
                    ))
                  }
                  {
                    (dataSet && dataSet.status === 'Completed' && (!dataSet.incompleteTasks || dataSet.incompleteTasks.length === 0) && !dataSet.nextTask && (
                      <span>{`This task has been completed. You can view the form by clicking the ${dataSet.displayName} button below`}</span>
                    ))
                  }
                  {
                    (dataSet && !dataSet.areDependentTasksCompleted && dataSet.incompleteTasks && dataSet.incompleteTasks.length > 0 && dataSet.status !== "Completed" ) && (
                      <span>{`Current state of the task is Pending. You will not be able to perform this task unless below task(s) are completed:`}</span>
                    )
                  }
                  {
                    (dataSet && !dataSet.areDependentTasksCompleted && dataSet.incompleteTasks && dataSet.incompleteTasks.length > 0 && dataSet.status !== "Completed" ) && (
                      <div class="bor-t">
                        {
                          dataSet.incompleteTasks.map((task, index) => (
                            <span>{index+1}. {task}<br /></span>
                          ))
                        }
                      </div>
                    )
                  }
                  {(dataSet && dataSet.completedTasks > 0 && dataSet.pendingTasks > 0) &&
                    <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                      <div class="flex-sb">
                        <span class="fs-14">{`${dataSet.pendingTasks}  Completed out of /  ${dataSet.completedTasks}`}</span>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {props.typeOfCard === 'courierCaseDetails' && dataSet &&
        <div class="row">
          <div class='col-xs-12 col-sm-6 col-md-6 col-lg-6 p-l-0 p-r-5' >
            <div class="workspace-cards fadeMoveUpAnimation">
              <div class="row justify-between align-center">
                <div class="display-flex">
                  <span class="workspace-cardsnumber fs-16 f-w-500">
                    <div class="h-24px w-24px">
                      {props.caseIcon}
                    </div>
                  </span>
                  <span class="m-l-10 fs-14 align-self-center">{dataSet.caseID}</span>
                </div>
              </div>
              <div class="row m-t-10">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Created By</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.displayName ? dataSet.displayName : "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Received Date</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.receivedDate ? formatDateTime(dataSet.receivedDate) : "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Received From</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.receivedFrom ? dataSet.receivedFrom : "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Description</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.courierDescription ? dataSet.courierDescription : "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Type Of Courier</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.typeOfCourier ? dataSet.typeOfCourier : "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Department</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.departmentDisplayName ? dataSet.departmentDisplayName : "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Whom To</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.whomTo ? dataSet.whomTo : "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Legal</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.isImportant ? "Yes" : "No"}</span></span>
                  </div>
                  {dataSet.isImportant &&
                    <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                      <div class="flex-sb">
                        <span class="fs-14">MD Response</span>
                      </div>
                      <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.acceptOrReject && dataSet.acceptOrReject === "accept" ? "Accepted" : "Rejected"}</span></span>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class='col-xs-12 col-sm-6 col-md-6 col-lg-6 p-l-5 p-r-0 display-flex justify-center align-start'>
            {/*
              Modification: Changed the md size of workspace parent div to 12 to make it responsive
              By: Devang
              Date: 27/05/2022
            */}
            {dataSet.uploadPackagePhotoSrc && dataSet.uploadPackagePhotoSrc.length &&
              <div class='col-xs-12 col-sm-6 col-md-12 col-lg-12 p-l-0 p-r-0 display-flex justify-center align-start'>
                <div class="workspace-cards fadeMoveUpAnimation w-full">
                  <div class="row justify-between align-center">
                    <div class="display-flex">
                      <span class="workspace-cardsnumber fs-16 f-w-500">
                        <div class="h-24px w-24px">
                          {props.stageIcon}
                        </div>
                      </span>
                      <span class="m-l-10 fs-14 align-self-center">Uploaded Images</span>
                    </div>
                  </div>
                  <div class="row m-t-10">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                      {
                        <div class="flex-sb borderteambottomtenant p-b-8 p-t-8 display-flex justify-center align-center">
                          {dataSet.uploadPackagePhotoSrc.map((imgSrc,id) => (
                            <div class="w-full" style="margin: 0 calc(1rem + 5px)">
                              <img id={`image-0-${id}`} class="cursor-pointer object-fit-contain w-full" src={imgSrc} onClick={(e)=> viewAllImages(e,id, 0)} />
                            </div>
                          ))}
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }
      {props.typeOfCard === 'courierDetails' && dataSet &&
        <div class="row">
          {/*
            Modification: Removed unnecessary condition of checking if dataSet exists from below code as it is already checked above
            By: Devang
            Date: 26/05/2022
          */}
          <div class='col-xs-12 col-sm-6 col-md-6 col-lg-6 p-l-0 p-r-0' >
            <div class="workspace-cards fadeMoveUpAnimation">
              <div class="row justify-between align-center">
                <div class="display-flex">
                  <span class="workspace-cardsnumber fs-16 f-w-500">
                    <div class="h-24px w-24px">
                      {props.caseIcon}
                    </div>
                  </span>
                  {/*
                    Modification: Handled dataSet property - an error was returned in console (reading property of undefined)
                    By: Devang
                    Date: 26/05/2022
                  */}
                  <span class="m-l-10 fs-14 align-self-center">{dataSet.courierDetails && dataSet.courierDetails.typeOfCourier}</span>
                </div>
              </div>
              <div class="row m-t-10">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Received from</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.courierDetails && dataSet.courierDetails.receivedFrom ? dataSet.courierDetails.receivedFrom : '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Whom To</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.courierDetails && dataSet.courierDetails.whomTo ? dataSet.courierDetails.whomTo : '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Legal?</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.courierDetails && dataSet.courierDetails.isImportant ? 'Yes' : 'No'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">MD Accepted?</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.courierDetails && dataSet.courierDetails.acceptOrReject === "accept" ? 'Yes' : 'No'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Received date</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.courierDetails && dataSet.courierDetails.receivedDate ? formatDateTime(dataSet.courierDetails.receivedDate) : '--'}</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {props.typeOfCard === 'callDetails' && dataSet &&
        <div class="row">
          {/*
            Modification: Removed unnecessary condition of checking if dataSet exists from below code as it is already checked above
            By: Devang
            Date: 26/05/2022
          */}
          <div class='col-xs-12 col-sm-6 col-md-6 col-lg-6 p-l-0 p-r-0' >
            <div class="workspace-cards fadeMoveUpAnimation">
              <div class="row justify-between align-center">
                <div class="display-flex">
                  <span class="workspace-cardsnumber fs-16 f-w-500">
                    <div class="h-24px w-24px">
                      {props.caseIcon}
                    </div>
                  </span>
                  {/*
                    Modification: Handled dataSet property - an error was returned in console (reading property of undefined)
                    By: Devang
                    Date: 26/05/2022
                  */}
                  <span class="m-l-10 fs-14 align-self-center">{dataSet.courierDetails && dataSet.courierDetails.typeOfCourier}</span>
                </div>
              </div>
              <div class="row m-t-10">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Received from</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.courierDetails && dataSet.courierDetails.receivedFrom ? dataSet.courierDetails.receivedFrom : '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Whom To</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.courierDetails && dataSet.courierDetails.whomTo ? dataSet.courierDetails.whomTo : '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Legal?</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.courierDetails && dataSet.courierDetails.isImportant ? 'Yes' : 'No'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">MD Accepted?</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.courierDetails && dataSet.courierDetails.acceptOrReject === "accept" ? 'Yes' : 'No'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Received date</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.courierDetails && dataSet.courierDetails.receivedDate ? formatDateTime(dataSet.courierDetails.receivedDate) : '--'}</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {props.typeOfCard === 'inboxCaseDetails' && dataSet &&
        <div class="row">
          {/*
            Modification: Removed unnecessary condition of checking if dataSet exists from below code as it is already checked above
            By: Devang
            Date: 26/05/2022
          */}
          <div class='col-xs-12 col-sm-6 col-md-6 col-lg-6 p-l-0 p-r-5' >
            <div class="workspace-cards fadeMoveUpAnimation">
              <div class="row justify-between align-center">
                <div class="display-flex">
                  <span class="workspace-cardsnumber fs-16 f-w-500">
                    <div class="h-24px w-24px">
                      {props.caseIcon}
                    </div>
                  </span>
                  <span class="m-l-10 fs-14 align-self-center">{dataSet.taskDetails && dataSet.taskDetails.caseID}</span>
                </div>
              </div>
              <div class="row m-t-10">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Customer Name</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(dataSet.taskDetails && dataSet.taskDetails.interaction && dataSet.taskDetails.interaction["dynamicProperties_customerName"]) ? dataSet.taskDetails.interaction["dynamicProperties_customerName"]: "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Source</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(dataSet.taskDetails && dataSet.taskDetails.interaction && dataSet.taskDetails.interaction["dynamicProperties_source"]) ? dataSet.taskDetails.interaction["dynamicProperties_source"]: "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Purchased Model</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(dataSet.taskDetails && dataSet.taskDetails.model) ? dataSet.taskDetails.model : (dataSet.taskDetails.interaction && dataSet.taskDetails.interaction['dynamicProperties_selectedModelName']) ? dataSet.taskDetails.interaction['dynamicProperties_selectedModelName']: '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Purchased Variant</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(dataSet.taskDetails && dataSet.taskDetails.variant) ? dataSet.taskDetails.variant : (dataSet.taskDetails.interaction && dataSet.taskDetails.interaction['dynamicProperties_selectedVariantName']) ? dataSet.taskDetails.interaction['dynamicProperties_selectedVariantName']: '--'}</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class='col-xs-12 col-sm-6 col-md-6 col-lg-6 p-l-5 p-r-0'>
            <div class="workspace-cards fadeMoveUpAnimation">
              <div class="row justify-between align-center">
                <div class="display-flex">
                  <span class="workspace-cardsnumber fs-16 f-w-500">
                    <div class="h-24px w-24px">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="black"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z" /></svg>
                    </div>
                  </span>
                  <span class="m-l-10 fs-14 align-self-center">Message Details</span>
                </div>
              </div>
              {/*
                Modification: Changed the data for this card and data-key binding
                By: Devang
                Date: 27/05/2022
              */}
              <div class="row m-t-10">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Message</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.message ? dataSet.message : "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Received At</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.createdAt ? formatDateTime(dataSet.createdAt) : "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Received From</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.userName ? dataSet.userName : "--"}</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {props.typeOfCard === 'inboxDetails' && dataSet &&
        <div class="row">
          {/*
            Modification: Removed unnecessary condition of checking if dataSet exists from below code as it is already checked above
            By: Devang
            Date: 26/05/2022
          */}
          <div class='col-xs-12 col-sm-6 col-md-6 col-lg-6 p-l-0 p-r-0' >
            <div class="workspace-cards fadeMoveUpAnimation">
              <div class="row justify-between align-center">
                <div class="display-flex">
                  <span class="workspace-cardsnumber fs-16 f-w-500">
                    <div class="h-24px w-24px">
                      {props.caseIcon}
                    </div>
                  </span>
                  {/*
                    Modification: Handled dataSet property - an error was returned in console (reading property of undefined)
                    By: Devang
                    Date: 26/05/2022
                  */}
                  <span class="m-l-10 fs-14 align-self-center">{dataSet.courierDetails && dataSet.courierDetails.typeOfCourier}</span>
                </div>
              </div>
              <div class="row m-t-10">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Received from</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.courierDetails && dataSet.courierDetails.receivedFrom ? dataSet.courierDetails.receivedFrom : '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Whom To</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.courierDetails && dataSet.courierDetails.whomTo ? dataSet.courierDetails.whomTo : '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Legal?</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.courierDetails && dataSet.courierDetails.isImportant ? 'Yes' : 'No'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">MD Accepted?</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.courierDetails && dataSet.courierDetails.acceptOrReject === "accept" ? 'Yes' : 'No'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Received date</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.courierDetails && dataSet.courierDetails.receivedDate ? formatDateTime(dataSet.courierDetails.receivedDate) : '--'}</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {props.typeOfCard === 'repairRequest' && dataSet &&
        <div class="row">
          <div class='col-xs-12 col-sm-6 col-md-6 col-lg-6 p-l-0 p-r-0' >
            <div class="workspace-cards fadeMoveUpAnimation">
              <div class="row justify-between align-center">
                <div class="display-flex">
                  <span class="workspace-cardsnumber fs-16 f-w-500">
                    <div class="h-24px w-24px">
                      {props.caseIcon}
                    </div>
                  </span>
                  <span class="m-l-10 fs-14 align-self-center">Not ok Checklist Items</span>
                </div>
              </div>
              <div class="row m-t-10">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                  {
                    (props.notOkChecklistItems && props.notOkChecklistItems.length !== 0) && props.notOkChecklistItems.map((checklistItem, index) => (
                      <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                        <div class="flex-sb">
                          <span class="fs-14">{index+1}. {checklistItem.displayName}</span>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          </div>
          <div class='col-xs-12 col-sm-6 col-md-6 col-lg-6 p-l-0 p-r-0'>
            <div class="workspace-cards fadeMoveUpAnimation">
              <div class="row justify-between align-center">
                <div class="display-flex">
                  <span class="workspace-cardsnumber fs-16 f-w-500">
                    <div class="h-24px w-24px">
                      {props.stageIcon}
                    </div>
                  </span>
                  <span class="m-l-10 fs-14 align-self-center">Uploaded Images</span>
                </div>
              </div>
              <div class="row m-t-10">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                  {
                    (props.notOkChecklistItems && props.notOkChecklistItems.length !== 0) && props.notOkChecklistItems.map((item, index) => (
                      <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                        {item.uploadFileSrc && item.uploadFileSrc.map((imgSrc,id) => (
                          <div style="margin-left: calc(1rem + 5px)">
                            <img id={`image-${index}-${id}`} class="cursor-pointer object-fit-contain" src={imgSrc} width="100" height="100" onClick={(e)=> viewAllImages(e,id, index)} />
                          </div>
                        ))}
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {props.typeOfCard === 'discountApproval' && dataSet &&
        <div class="row">
          {/*
            Modification: Removed unnecessary condition of checking if dataSet exists from below code as it is already checked above
            By: Devang
            Date: 26/05/2022
          */}
          <div class='col-xs-12 col-sm-6 col-md-6 col-lg-6 p-l-0 p-r-0' >
            <div class="workspace-cards fadeMoveUpAnimation">
              <div class="row justify-between align-center">
                <div class="display-flex">
                  <span class="workspace-cardsnumber fs-16 f-w-500">
                    <div class="h-24px w-24px">
                      {props.caseIcon}
                    </div>
                  </span>
                  <span class="m-l-10 fs-14 align-self-center">{dataSet.caseID}</span>
                </div>
              </div>
              <div class="row m-t-10">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Customer Name</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(dataSet.interaction && dataSet.interaction["dynamicProperties_customerName"]) ? dataSet.interaction["dynamicProperties_customerName"]: "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Source</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(dataSet.interaction && dataSet.interaction["dynamicProperties_source"]) ? dataSet.interaction["dynamicProperties_source"]: "--"}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Purchased Model</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.model ? dataSet.model : (dataSet.interaction && dataSet.interaction['dynamicProperties_selectedModelName']) ? dataSet.interaction['dynamicProperties_selectedModelName']: '--'}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Purchased Variant</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.variant ? dataSet.variant : (dataSet.interaction && dataSet.interaction['dynamicProperties_selectedVariantName']) ? dataSet.interaction['dynamicProperties_selectedVariantName']: '--'}</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class='col-xs-12 col-sm-6 col-md-6 col-lg-6 p-l-0 p-r-0'>
            <div class="workspace-cards fadeMoveUpAnimation">
              <div class="row justify-between align-center">
                <div class="display-flex">
                  <span class="workspace-cardsnumber fs-16 f-w-500">
                    <div class="h-24px w-24px">
                      {props.stageIcon}
                    </div>
                  </span>
                  <span class="m-l-10 fs-14 align-self-center">Purchase Details</span>
                </div>
              </div>
              <div class="row m-t-10">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Purchase Price</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{getFormattedAmount(700000)}</span></span>
                  </div>
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Age</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">40 Days</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class='col-xs-12 col-sm-6 col-md-6 col-lg-6 p-l-0 p-r-0'>
            <div class="workspace-cards fadeMoveUpAnimation">
              <div class="row justify-between align-center">
                <div class="display-flex">
                  <span class="workspace-cardsnumber fs-16 f-w-500">
                    <div class="h-24px w-24px">
                      {props.stageIcon}
                    </div>
                  </span>
                  <span class="m-l-10 fs-14 align-self-center">Discount Details</span>
                </div>
              </div>
              <div class="row m-t-10">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                  <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                    <div class="flex-sb">
                      <span class="fs-14">Requested Discount</span>
                    </div>
                    <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{dataSet.interaction ? getFormattedAmount(dataSet.interaction['dynamicProperties_discount']): getFormattedAmount(0)}</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {props.typeOfCard === 'formCard' && props.group && props.groupProps && props.interactionObj &&
        <div class="row">
          {/*
            Modification: Removed unnecessary condition of checking if dataSet exists from below code as it is already checked above
            By: Devang
            Date: 26/05/2022
          */}
          <div class='col-xs-12 col-sm-12 col-md-12 col-lg-12 p-l-0 p-r-5' >
            <div class="workspace-cards fadeMoveUpAnimation">
              <div class="row justify-between align-center">
                <div class="display-flex">
                  <span class="m-l-10 fs-14 align-self-center">{props.group}</span>
                </div>
              </div>
              <div class="row m-t-10">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                  {
                    props.groupProps && props.groupProps.length > 0 && props.groupProps.map((groupProp) => (
                      <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                        <div class="flex-sb">
                          {groupProp.name !== "selectedCouponID" ?
                            <span class="fs-14">{groupProp.displayName}</span>
                            :
                            <span class="fs-14">Total offer amount</span>
                          }
                        </div>
                        {
                          groupProp.isAmount ? (
                            <span id={groupProp.displayName} class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{props.interactionObj['dynamicProperties_'+ groupProp.name] ? getFormattedAmount(props.interactionObj['dynamicProperties_'+ groupProp.name]): '--'}</span></span>
                          ) : (groupProp.name !== "selectedCouponID" && groupProp.formType !== 'date') ? (
                            <span id={groupProp.displayName} class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{props.interactionObj['dynamicProperties_'+ groupProp.name] ? props.interactionObj['dynamicProperties_'+ groupProp.name]: '--'}</span></span>
                          ) : (groupProp.name !== "selectedCouponID" && groupProp.formType === 'date') ? (
                            <span id={groupProp.displayName} class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{props.interactionObj['dynamicProperties_'+ groupProp.name] ? moment(new Date(props.interactionObj["dynamicProperties_" + groupProp.name])).format('DD-MM-YYYY'): '--'}</span></span>
                          ) : (
                            props.coupons && props.coupons.length > 0 && (
                              <p class="formLabel fs-15">{props.interactionObj["dynamicProperties_"+groupProp.name] && getFormattedAmount(props.interactionObj["dynamicProperties_"+groupProp.name].split(',').reduce((acc, obj) => {return acc + Number(props.coupons.find(coupon => coupon.uuid === obj).amount);}, 0))}</p>
                            )
                          )
                        }
                      </div>
                    ))
                  }

                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {props.typeOfCard === 'customerDetails' && props.interactionObj &&
        <div class="workspace-cards fadeMoveUpAnimation">
          <div class="row justify-between align-center">
            <div class="display-flex">
              <span class="workspace-cardsnumber fs-16 f-w-500">
                <div class="h-24px w-24px">
                  {props.caseIcon}
                </div>
              </span>
              <span class="m-l-10 fs-14 align-self-center">{props.interactionObj.uniqueID}</span>
            </div>
          </div>
          <div class="row m-t-10">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
              <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                <div class="flex-sb">
                  <span class="fs-14">Customer Name</span>
                </div>
                <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(props.interactionObj && props.interactionObj["dynamicProperties_customerName"]) ? props.interactionObj["dynamicProperties_customerName"]: "--"}</span></span>
              </div>
              <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                <div class="flex-sb">
                  <span class="fs-14">Source</span>
                </div>
                <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(props.interactionObj && props.interactionObj["dynamicProperties_source"]) ? props.interactionObj["dynamicProperties_source"]: "--"}</span></span>
              </div>
              <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                <div class="flex-sb">
                  <span class="fs-14">Model</span>
                </div>
                <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(props.interactionObj && props.interactionObj['dynamicProperties_selectedModelName']) ? props.interactionObj['dynamicProperties_selectedModelName']: '--'}</span></span>
              </div>
              <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                <div class="flex-sb">
                  <span class="fs-14">Variant</span>
                </div>
                <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(props.interactionObj && props.interactionObj['dynamicProperties_selectedVariantName']) ? props.interactionObj['dynamicProperties_selectedVariantName']: '--'}</span></span>
              </div>
              <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                <div class="flex-sb">
                  <span class="fs-14">VIN</span>
                </div>
                <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(props.interactionObj && props.interactionObj['dynamicProperties_vin']) ? props.interactionObj['dynamicProperties_vin']: '--'}</span></span>
              </div>
            </div>
          </div>
        </div>
      }
      {props.typeOfCard === 'policyDetails' && props.interactionObj &&
        <div class="workspace-cards fadeMoveUpAnimation">
          <div class="row justify-between align-center">
            <div class="display-flex">
              <span class="workspace-cardsnumber fs-16 f-w-500">
                <div class="h-24px w-24px">
                  {props.caseIcon}
                </div>
              </span>
              <span class="m-l-10 fs-14 align-self-center">{props.interactionObj.uniqueID}</span>
            </div>
          </div>
          <div class="row m-t-10">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
              <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                <div class="flex-sb">
                  <span class="fs-14">Policy Number</span>
                </div>
                <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(props.interactionObj && props.interactionObj["dynamicProperties_policyNumber"]) ? props.interactionObj["dynamicProperties_policyNumber"]: "--"}</span></span>
              </div>
              <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                <div class="flex-sb">
                  <span class="fs-14">Policy Issue Date</span>
                </div>
                <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(props.interactionObj && props.interactionObj["dynamicProperties_policyIssuedDate"]) ? formatDateTime(props.interactionObj["dynamicProperties_policyIssuedDate"]): "--"}</span></span>
              </div>
              <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                <div class="flex-sb">
                  <span class="fs-14">Policy Issued By</span>
                </div>
                <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(props.interactionObj && props.interactionObj['dynamicProperties_policyIssuedBy']) ? props.interactionObj['dynamicProperties_policyIssuedBy']: '--'}</span></span>
              </div>
              <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                <div class="flex-sb">
                  <span class="fs-14">Policy IDV</span>
                </div>
                <span class="text-primary-tenant p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(props.interactionObj && props.interactionObj['dynamicProperties_policyIDV']) ? getFormattedAmount(props.interactionObj['dynamicProperties_policyIDV']): '--'}</span></span>
              </div>
              <div class="flex-sb borderteambottomtenant p-b-8 p-t-8">
                <div class="flex-sb">
                  <span class="fs-14">Policy Amount</span>
                </div>
                <span class="text-primary p-l-12 p-r-24 f-w-600"><span class="fs-14 first-letter-capital">{(props.interactionObj && props.interactionObj['dynamicProperties_amount']) ? getFormattedAmount(props.interactionObj['dynamicProperties_amount']): '--'}</span></span>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default ListSingleCard;
